<div class="card-wrapper">
  <ion-card>
    <ion-card-header class="card-header">
      <img src="../../../assets/images/sademo.png" alt="sad emoji" />
      <h4>{{ "auto-refresh.title" | translate }}</h4>
    </ion-card-header>
    <ion-card-content>
      <div>
        <p>{{ "auto-refresh.description" | translate }} {{currencySymbol}}{{data.int_threshold[preferredCurrency]}}</p>
      </div>
      <ion-button class="purple-btn" (click)="turnOff()">
        {{ "auto-refresh.turn_off_button" | translate }}
        <!-- <div *ngIf="showSpinner" class="spinners">
          <mat-progress-spinner class="spinner-circle" mode="determinate" [value]="progress" diameter="40">
          </mat-progress-spinner>
        </div>
        <mat-icon *ngIf="progress == 100" class="tick-mark">done </mat-icon> -->
      </ion-button>
    </ion-card-content>
  </ion-card>
</div>
